import { render, staticRenderFns } from "./ChatTicket.vue?vue&type=template&id=c2863518&scoped=true&"
import script from "./ChatTicket.vue?vue&type=script&lang=js&"
export * from "./ChatTicket.vue?vue&type=script&lang=js&"
import style0 from "./ChatTicket.vue?vue&type=style&index=0&id=c2863518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2863518",
  null
  
)

export default component.exports